import './PersonalManagerBottomSheet.sass';

import React, { FC } from 'react';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { BottomBar, Button } from '$uikit';
import { useTranslator } from '$hooks';
import { useSelector } from 'react-redux';
import { managerLinkSelector } from '$store/main';

export const PersonalManagerBottomSheet: FC<{ onClose: () => void }> = ({ onClose }) => {
  const t = useTranslator();
  const managerLink = useSelector(managerLinkSelector);
  return (
    <BottomSheet
      onClose={onClose}
      className="PersonalManagerBottomSheet"
      title={t('personal_manager_bottomsheet_title')}
    >
      <div className="PersonalManagerBottomSheet__content">
        {t('personal_manager_bottomsheet_content')}
      </div>
      <div className="PersonalManagerBottomSheet__actions">
        <Button onClick={() => window.open(managerLink, '_blank')}>
          {t('personal_manager_bottomsheet_button')}
        </Button>
      </div>
    </BottomSheet>
  );
};
